
export const ResultUtils = {
    validateGetQuizzesByLeaugeRequest (request) {
        if (request) {
            const keys = Object.getOwnPropertyNames(request)
            if (keys.indexOf('ligaId') === -1) {
                throw new Error('Missing ligaId attribute on result object')
            }
            if (keys.indexOf('withQuestions') === -1) {
                throw new Error('Missing withQuestions attribute on result object')
            }
            if (keys.indexOf('inMonth') === -1) {
                throw new Error('Missing inMonth attribute on result object')
            }
        } else {
            throw new Error('no request object')
        }
    },
    validateGetResultsForQuizRequest (request) {
        if (request) {
            const keys = Object.getOwnPropertyNames(request)
            if (keys.indexOf('ligaId') === -1) {
                throw new Error('Missing ligaId attribute on result object')
            }
            if (keys.indexOf('quizId') === -1) {
                throw new Error('Missing month attribute on result object')
            }
            if (keys.indexOf('limit') === -1) {
                throw new Error('Missing limit attribute on result object')
            }
        } else {
            throw new Error('no request object')
        }
    },
    validateGetTotalPointsByLeagueRequest (request) {
        if (request) {
            const keys = Object.getOwnPropertyNames(request)
            if (keys.indexOf('ligaId') === -1) {
                throw new Error('Missing ligaId attribute on result object')
            }
            if (keys.indexOf('limit') === -1) {
                throw new Error('Missing limit attribute on result object')
            }
        } else {
            throw new Error('no request object')
        }
    }
}
